@if (tilinpaatosViewDataObservable | async; as tilinpaatosViewData) {
  <div>
    @if (tilinpaatosViewData.tilinpaatosHasBeenExported) {
      <div>
        @if (tilinpaatosViewData.tpPages?.length) {
          <button mat-button class="secondarybutton" style="margin: 25px" (click)="downloadPdf('tilinpaatos')">{{ 'reports-lemonaid.lataa-tilinpaatos' | translate | async }}</button>
        }
        @if (tilinpaatosViewData.ptkirjaPages?.length) {
          <button mat-button class="secondarybutton" style="margin: 25px" (click)="downloadPdf('poytakirja')">{{ 'reports-lemonaid.lataa-poytakirja' | translate | async }}</button>
        }
      </div>
      @if (tilinpaatosViewData.mode === 'view') {
        <!-- Tilinpäätös -->
        @if (tilinpaatosViewData.tpPages?.length) {
          <div>
            @for (page of tilinpaatosViewData.tpPages; track page) {
              <div class="lemon-mat-elevation-z4" style="margin: 1em">
                @if (page.getImageObservable() | async; as kuva) {
                  <img [src]="kuva" style="width: 100%" />
                } @else {
                  <div style="text-align: center; padding: 50px 0">
                    <mat-spinner style="display: inline-block"></mat-spinner>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Luettelo kirjanpidoista -->
        @if (tilinpaatosViewData.luetteloKirjanpidoistaPages?.length) {
          <div>
            @for (page of tilinpaatosViewData.luetteloKirjanpidoistaPages; track page) {
              <div class="lemon-mat-elevation-z4" style="margin: 1em">
                @if (page.getImageObservable() | async; as kuva) {
                  <img [src]="kuva" style="width: 100%" />
                } @else {
                  <div style="text-align: center; padding: 50px 0">
                    <mat-spinner style="display: inline-block"></mat-spinner>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Hallituksen ptkirja -->
        @if (tilinpaatosViewData.ptkirjaPages?.length) {
          <div>
            @for (page of tilinpaatosViewData.ptkirjaPages; track page) {
              <div class="lemon-mat-elevation-z4" style="margin: 1em">
                @if (page.getImageObservable() | async; as kuva) {
                  <img [src]="kuva" style="width: 100%" />
                } @else {
                  <div style="text-align: center; padding: 50px 0">
                    <mat-spinner style="display: inline-block"></mat-spinner>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
      @if (tilinpaatosViewData.mode === 'edit') {
        <div class="heading light-blue-text">{{ 'reports-lemonaid.allekirjoitukset' | translate | async }}</div>
        <p [innerHTML]="'reports-lemonaid.tilinpaatoksen-allekirjoittaa' | translate | async"></p>
        <p>{{ 'reports-lemonaid.hyvaksymisesta-on-laadittava' | translate | async }}</p>
        <p>{{ 'reports-lemonaid.alla-on-listattuna' | translate | async }}</p>
        <form>
          <p style="font-weight: bold; margin: 20px 0">{{ 'reports-lemonaid.tilinpaatoksen-allekirjoittavat-henkilot' | translate | async }}</p>
          <div>
            @for (boardMember of lomake.boardMembers; track boardMember) {
              <div class="signer-row">
                <!-- <mat-checkbox class="space-on-right" formControlName="selected"></mat-checkbox> -->
                <div [class.disabled-user]="boardMember().disabled()" style="width: 200px" class="space-on-right">{{ boardMember.name().value() }}</div>
                <div class="space-on-right" style="width: 250px">
                  @for (role of allBoardMemberRolesObservable | async; track role.key) {
                    @if (role.key === boardMember.role().value()) {
                      {{ role.name }}
                    }
                  }
                </div>
                @if (boardMember().disabled() && boardMember.role().value() !== 'varajasen') {
                  <mat-error style="max-width: 400px; font-size: 12px">{{ 'reports-lemonaid.no-lemonaid-user' | translate | async }}</mat-error>
                }
              </div>
            }
          </div>
          <p style="font-weight: bold; margin: 20px 0">{{ 'reports-lemonaid.hyvaksymispoytakirjan-tiedot' | translate | async }}</p>
          <div style="display: flex; flex-direction: row">
            <mat-form-field style="width: 10rem">
              <mat-label>{{ 'reports-lemonaid.pvm' | translate | async }}</mat-label>
              <input matInput [matDatepicker]="dp" [formField]="lomake.boardMinutesDate" />
              <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
            <mat-form-field style="width: 15rem; margin-left: 4.5rem">
              <mat-label>{{ 'reports-lemonaid.poytakirjan-numero' | translate | async }}</mat-label>
              <input type="text" [formField]="lomake.boardMinutesNumber" matInput />
            </mat-form-field>
          </div>
        </form>
        @if (commonError()) {
          <div class="red-text common-error" style="margin-top: 20px; text-align: center">{{ commonError() }}</div>
        }
        <div class="button-container">
          <button mat-button class="primarybutton" style="padding-left: 1rem; padding-right: 1rem" [disabled]="tilinpaatosSigningDisabledObservable | async" (click)="approveSigners()">{{ 'reports-lemonaid.hyvaksy-valinta' | translate | async }}</button>
        </div>
      }
      @if (tilinpaatosViewData.mode === 'view' && !tilinpaatosViewData.signed) {
        <div>
          <div class="heading light-blue-text">{{ 'reports-lemonaid.allekirjoitukset' | translate | async }}</div>
          @if (tilinpaatosMissingSignaturesObservable | async) {
            <div class="btn-on-right-container">
              <button mat-button class="gray-text-btn" (click)="editSigners()">{{ 'reports-lemonaid.muokkaa-allekirjoittajia' | translate | async }}</button>
            </div>
          }
          <div class="signers-container">
            @for (signer of approvedSignersObservable | async; track signer) {
              <div>
                <!-- Top text if signed -->
                @if (!!signer.signedAt) {
                  <div>
                    <div style="display: flex; flex-direction: row; color: gray">
                      <mat-icon style="font-size: 40px; width: 2.5rem; height: 2.5rem">lock</mat-icon>
                      <div>
                        <div>{{ 'reports-lemonaid.allekirjoitettu-sahkoisesti' | translate | async }}</div>
                        <div>{{ signer.name }} {{ signer.signedAt | ltimestamp | async }}</div>
                      </div>
                    </div>
                  </div>
                }
                <!-- Top text if not signed and current user -->
                @if (!signer.signedAt && signer.isCurrentUser) {
                  <div>
                    <div style="display: flex; flex-direction: row; color: gray">
                      <button mat-button class="primarybutton" style="padding-left: 1rem; padding-right: 1rem" (click)="saveSignature()">{{ 'reports-lemonaid.allekirjoita' | translate | async }}</button>
                    </div>
                  </div>
                }
                <!-- Top text if not signed and not current user -->
                @if (!signer.signedAt && !signer.isCurrentUser) {
                  <div>
                    <div style="display: flex; flex-direction: row; color: gray; height: 44px; align-items: center">
                      <div class="red-text">{{ 'reports-lemonaid.allekirjoitus-puuttuu' | translate | async }}</div>
                    </div>
                  </div>
                }
                <!-- Border and underline text -->
                <div class="underline-info">
                  <div>{{ signer.name }}</div>
                  <div style="white-space: pre-wrap">{{ signer.rolesLocalized }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div style="padding: 70px 20px; text-align: center">{{ 'reports-lemonaid.tilinpaatos-ei-viela-tehty' | translate | async }}</div>
    }
  </div>
} @else {
  <div style="text-align: center; padding: 50px 0">
    <mat-spinner style="display: inline-block"></mat-spinner>
    <div style="text-align: center; padding: 20px 0">{{ 'reports-lemonaid.tilinpaatoksen-tietoja-ladataan' | translate | async }}</div>
  </div>
}
